import React from "react";
import { SectionHeader } from "../SectionHeader";
import { validateEmail, validateZipCode, validateNotEmpty, validateOptionalPhoneNumber, getErrorMessage, getNestedProp } from "./../../../shared/formUtils";
import { Dropdown } from "./../../Dropdown";
import { Row, Col } from "./../../Grid";
import Input from "./../../Input";
var defaultValidations = {
  email: {
    required: "Please enter valid email",
    validate: function validate(e) {
      return validateEmail(e);
    }
  },
  firstName: {
    validate: function validate(e) {
      return validateNotEmpty(e) || "Please enter valid first name";
    }
  },
  lastName: {
    validate: function validate(e) {
      return validateNotEmpty(e) || "Please enter valid last name";
    }
  },
  address: {
    validate: function validate(e) {
      return validateNotEmpty(e) || "Please enter valid address";
    }
  },
  city: {
    validate: function validate(e) {
      return validateNotEmpty(e) || "Please enter valid city";
    }
  },
  state: {
    required: "Please select a valid state"
  },
  zipCode: {
    required: "Please enter valid zip code",
    validate: function validate(e) {
      return validateZipCode(e);
    }
  },
  phoneNumber: {
    required: !1,
    invalid: "Please enter valid phone number",
    validate: function validate(e) {
      return validateOptionalPhoneNumber(e);
    }
  }
};
export function ShippingInformation(_ref) {
  var e = _ref.email,
      a = _ref.firstName,
      t = _ref.lastName,
      r = _ref.address,
      l = _ref.city,
      _ref$shippableStates = _ref.shippableStates,
      i = _ref$shippableStates === void 0 ? [] : _ref$shippableStates,
      n = _ref.zipCode,
      o = _ref.phoneNumber,
      _ref$showHeader = _ref.showHeader,
      s = _ref$showHeader === void 0 ? !0 : _ref$showHeader,
      _ref$showEmail = _ref.showEmail,
      m = _ref$showEmail === void 0 ? !0 : _ref$showEmail,
      _ref$validations = _ref.validations,
      d = _ref$validations === void 0 ? defaultValidations : _ref$validations,
      _ref$inputPrefix = _ref.inputPrefix,
      c = _ref$inputPrefix === void 0 ? "shippingAddress" : _ref$inputPrefix,
      p = _ref.errors,
      u = _ref.register,
      E = _ref.setValue,
      R = _ref.normalizePhone,
      g = _ref.isValidState,
      _ref$liteDisplay = _ref.liteDisplay,
      N = _ref$liteDisplay === void 0 ? !1 : _ref$liteDisplay;
  var h = N ? 12 : 6,
      f = {};
  return f[c] = d, React.createElement(React.Fragment, null, s && React.createElement(SectionHeader, {
    title: "Shipping Information"
  }), m && React.createElement(Row, null, React.createElement(Col, null, React.createElement(Input, {
    id: "email",
    name: "".concat(c, "[email]"),
    label: "Email",
    placeholder: "Email",
    ref: u && u(d.email),
    error: getErrorMessage(p, [c, "email"], f)
  }))), React.createElement(Row, null, N ? React.createElement(Col, {
    xs: 12,
    sm: 12
  }, React.createElement(Input, {
    id: "name",
    name: "".concat(c, "[name]"),
    label: "Name",
    placeholder: "Name",
    ref: u && u(),
    disabled: !0
  })) : React.createElement(React.Fragment, null, React.createElement(Col, {
    xs: 12,
    sm: 6
  }, React.createElement(Input, {
    id: "first_name",
    name: "".concat(c, "[firstName]"),
    label: "First Name",
    placeholder: "First Name",
    ref: u && u(d.firstName),
    error: getNestedProp(p, [c, "firstName", "message"])
  })), React.createElement(Col, {
    xs: 12,
    sm: 6
  }, React.createElement(Input, {
    id: "last_name",
    name: "".concat(c, "[lastName]"),
    label: "Last Name",
    placeholder: "Last Name",
    ref: u && u(d.lastName),
    error: getNestedProp(p, [c, "lastName", "message"])
  })))), React.createElement(Row, null, React.createElement(Col, null, React.createElement(Input, {
    id: "address",
    name: "".concat(c, "[address]"),
    label: "Address",
    placeholder: "Address",
    ref: u && u(d.address),
    error: getNestedProp(p, [c, "address", "message"])
  }))), N && React.createElement(Row, null, React.createElement(Col, null, React.createElement(Input, {
    id: "address2",
    name: "".concat(c, "[address2]"),
    ref: u && u()
  }))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12,
    sm: h
  }, React.createElement(Input, {
    id: "city",
    name: "".concat(c, "[city]"),
    label: "City",
    placeholder: "City",
    ref: u && u(d.city),
    error: getNestedProp(p, [c, "city", "message"])
  })), React.createElement(Col, {
    xs: 12,
    sm: h
  }, React.createElement(Dropdown, {
    id: "state",
    name: "".concat(c, "[state]"),
    label: "Select State",
    placeholderText: "Select State",
    items: i,
    showErrorMessage: !0,
    error: getErrorMessage(p, [c, "state"], f),
    ref: u && u(Object.assign(Object.assign({}, d.state), {
      validate: function validate(e) {
        return g && g(e);
      }
    }))
  }))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12,
    sm: h
  }, React.createElement(Input, {
    id: "zip_code",
    name: "".concat(c, "[zipCode]"),
    label: "ZIP Code",
    placeholder: "00000",
    ref: u && u(d.zipCode),
    error: getErrorMessage(p, [c, "zipCode"], f),
    onChange: function onChange(e) {
      var a = e.target.value.replace(/[^\d]/g, "");
      a.length > 5 && (a = a.slice(0, 5)), E && E("".concat(c, "[zipCode]"), a);
    }
  })), !N && React.createElement(Col, {
    xs: 12,
    sm: 6
  }, React.createElement(Input, {
    id: "phone_number",
    name: "".concat(c, "[phoneNumber]"),
    label: "Phone Number (optional)",
    placeholder: "000-000-00000",
    ref: u && u(d.phoneNumber),
    error: getErrorMessage(p, [c, "phoneNumber"], f),
    onChange: function onChange(e) {
      R && E && E("".concat(c, "[phoneNumber]"), R(e.target.value));
    }
  }))));
}
export default ShippingInformation;